import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/styles/index.css'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

if (process.env.NODE_ENV === 'production') {
  const bugsnagClient = bugsnag('b4eea2773869626bc25dbaa3b2f5426d')
  bugsnagClient.use(bugsnagVue, Vue)
}

Vue.config.productionTip = true

const app = new Vue({
  router,
  store,
  render: h => h(App)
})
app.$mount('#app')
